import VueI18n from 'vue-i18n'
import { i18n } from '@/utils/i18n'

export const getI18n = (): VueI18n => i18n
